import useSound from 'use-sound';
import { gameVolumeState } from '@/components/features/casino/crash/state';
import { useAtomValue } from 'jotai';
import { usePageVisibility } from '@/hooks/usePageVisibility';
import { useEffect } from 'react';

export const useCrashBgSound = () => {
  const globalVolume = useAtomValue(gameVolumeState);
  const [play, { sound: bgSound, pause, stop }] = useSound(
    '/audios/crash/bg.mp3',
    {
      volume: globalVolume / 100,
      loop: true,
      interrupt: true,
    },
  );

  const playCrashBg = () => {
    if (bgSound && bgSound.playing()) {
      // console.log('crash bg is playing return');
      return;
    } else {
      if (globalVolume === 0) {
        // console.log('crash bg volume is 0 return');
        return;
      }
      play();
    }
  };

  const isPageActive = usePageVisibility();
  useEffect(() => {
    if (isPageActive) {
      if (globalVolume === 0) {
        console.log('crash bg volume is 0 return');
        return;
      }
      playCrashBg();
    } else {
      pause();
    }
  }, [isPageActive]);

  useEffect(() => {
    return () => {
      stop();
    };
  }, [bgSound]);

  return {
    playCrashBg: playCrashBg,
    pauseCrashBg: pause,
  };
};

export const useCrashBetSound = () => {
  const globalVolume = useAtomValue(gameVolumeState);
  const [playCrashBetSound, { sound, pause, stop }] = useSound(
    '/audios/rush/bet.mp3',
    {
      volume: globalVolume / 100,
      interrupt: true,
    },
  );
  return {
    playCrashBetSound,
  };
};

export const useCrashWinSound = () => {
  const globalVolume = useAtomValue(gameVolumeState);
  const [playCrashWinSound, { sound, pause, stop }] = useSound(
    '/audios/rush/win.mp3',
    {
      volume: globalVolume / 100,
      interrupt: true,
    },
  );
  return {
    playCrashWinSound,
  };
};
